import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OffersNavigationButtonsComponent } from './navigation-buttons/navigation-buttons.component';
import { OfferComponent } from './offer/offer.component';

@Component({
  selector: 'details-offers',
  standalone: true,
  imports: [
    TranslateModule,
    OffersNavigationButtonsComponent,
    OfferComponent
  ],
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsOffersComponent {
  public offers: InputSignal<any[]> = input.required<any[]>();
  public fromBottomSheet: InputSignal<boolean> = input.required<boolean>();
}